import { render, staticRenderFns } from "./RoleBadge.vue?vue&type=template&id=d9c2c1d4&scoped=true&"
import script from "./RoleBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./RoleBadge.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RoleBadge.vue?vue&type=style&index=0&id=d9c2c1d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c2c1d4",
  null
  
)

export default component.exports